import { useState } from "react";
import { useNavigate } from "react-router-dom";

const Search = () => {
  const [input, setInput] = useState("");
  const navigate = useNavigate();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    const searchParams = new URLSearchParams();
    if (input.trim()) {
      searchParams.set("search", input.trim());
    }

    navigate(`/blog/posts?${searchParams.toString()}`);
  };

  return (
    <form onSubmit={handleSubmit} className="flex gap-2">
      <input
        type="text"
        placeholder="ძებნა..."
        value={input}
        onChange={(e) => setInput(e.target.value)}
        className="border px-2 py-1 rounded-md"
        style={{
          width: "75%",
        }}
      />
      <button
        type="submit"
        className="bg-blue-800 text-white text-sm px-4 py-1 rounded-md"
      >
        ძებნა
      </button>
    </form>
  );
};

export default Search;
